import { useState, useEffect, useCallback } from "react";
import { useWorker } from "../workers/useWorker";
import { useAsyncEffect } from "../Hooks/AsyncEffect";
import { Button, Loading } from "@aidkitorg/component-library";

export function Changes(props: { current: any, updated: any }) {
  const [logDiff, setLogDiff] = useState('');
  const [loading, setLoading] = useState(false);
  // Use the worker
  const diffWorker = useWorker('jsonDiff');

  const getDiff = useCallback(async () => {

    if (JSON.stringify(props.current) === '{}' || JSON.stringify(props.updated) === '{}') {
      setLogDiff('');
      return;
    }
    if (loading) return;
    
    setLoading(true);
    // Execute the diff in the worker
    try {
      const result = await diffWorker.execute([props.current, props.updated]);
      console.log("Diff result:", result);
      setLogDiff(result as any ?? 'No changes!');
    } catch (error) {
      console.error('Error in diff worker:', error);
      setLogDiff('Error calculating diff');
    } finally {
      setLoading(false);
    }
  }, [diffWorker, props.current, props.updated]);

  return <>
    <Button onClick={getDiff}>Get Changes</Button>
    <Loading loading={loading} labels={[{ content: 'Calculating changes... this can take a minute so grab a snack. If you leave this page, you will have to start over.' }]}><pre>{logDiff}</pre></Loading>
  </>
}